<template>
	<div class="agreement">
		<slot ></slot>
	</div>

</template>
<script >
	export default{
		name:'paco-agreement'
	}
</script>





// WEBPACK FOOTER //
// Agreement.vue?12cf1b99